// İkincil irtibat kişileri — panelin ortak kuralları (Profil sekmesi, Sidebar tamamlanma oranı,
// anasayfa uyarı bandı aynı yerden okur).
// TEK KAYNAK (29.09.2026): user_secondary_contacts — admin'in müşteri detayında eklediği liste ile
// müşterinin Profil'den eklediği AYNI listedir. Okuma: get-user-infos (müşteri) / kullanıcı listesi
// (admin) → secondaryContacts. Yazma: update-user-profile { secondaryContacts } — BE listeyi
// BÜTÜNÜYLE değiştirir, bu yüzden kaydederken her zaman TAM liste gönderilir.

// Profil sekme anahtarı (Sidebar/anasayfa "eksik" maddeleri bu sekmeye yönlendirir).
export const SECONDARY_CONTACT_TAB = "secondary-contact";

// i-ikonu metni (kullanıcı tarifi, 28.09.2026).
export const SECONDARY_CONTACT_INFO =
  "Size ulaşamadığımız zaman ulaşacağımız ikinci irtibat kişisi olarak eklenecektir.";

// ONAY AKIŞI ANAHTARI (kullanıcı kararı 22.10.2026: KAPALI). false iken eklenen kişiye mail GİTMEZ,
// onay beklenmez: durum çipi, "daveti yeniden gönder" ve onay notu gösterilmez; kişinin eklenmiş
// olması yeterlidir (eklemek yine zorunlu). Yeniden açmak için true yapın — BE'de de
// users.php SECONDARY_CONTACT_APPROVAL_FLOW true olmalı. Aşağıdaki açıklama akış AÇIKKEN geçerlidir.
export const SECONDARY_CONTACT_APPROVAL_FLOW = false;

// TCKN ve Ev Adresi alanları (onay akışıyla birlikte kapatıldı, 22.10.2026). Alanlar artık
// Ad, Soyad, E-posta, Telefon, Yakınlık — hepsi zorunlu. Eski kayıtlardaki TCKN/adres değerleri
// kaydederken AYNEN geri gönderilir (silinmez). Yeniden göstermek için true yapın.
export const SECONDARY_CONTACT_SHOW_TCKN_ADDRESS = false;

// Akış kapalıyken zorunlu alanlar: ad, soyad, e-posta, telefon, yakınlık.
export const SECONDARY_CONTACT_REQUIRED_MESSAGE = "Ad, soyad, e-posta, telefon ve yakınlık durumu zorunludur.";
export function isSecondaryContactComplete({ name, lastname, email, phone, relation } = {}) {
  return [name, lastname, email, phone, relation].every((v) => String(v ?? "").trim() !== "");
}

// ONAY AKIŞI (06.10.2026, BE stage): yeni eklenen kişiye onay e-postası gider; kişi e-postadaki
// bağlantıyla sitede (/secondary-contact/{contactID}) onaylar ya da reddeder. Satır statüsü:
//   3 = onay bekliyor · 1 = onayladı · 2 = reddetti · 0 = kaldırıldı (listelere hiç gelmez)
// Onay E-POSTA ADRESİNE bağlıdır: adres değişirse yeni onay istenir; ad/telefon değişikliği onayı korur.
export const SECONDARY_CONTACT_STATUS = Object.freeze({ REMOVED: 0, APPROVED: 1, REJECTED: 2, PENDING: 3 });

// Kaydedilirken listede kalan kişiye eklenen bilgi notu (Profil + admin müşteri detayı).
export const SECONDARY_CONTACT_INVITE_NOTE =
  "Yeni eklediğiniz kişiye onay e-postası gönderilir. Kişi onaylayana kadar \"Onay bekliyor\" olarak görünür.";

// Kişinin onay durumu: "pending" | "approved" | "rejected" | "legacy" | "" (bilinmiyor / kaydedilmemiş).
// "legacy": onay akışından ÖNCE eklenmiş kişi. BE bu satırları statü 1 (onaylı) olarak tutar ama kişi
// hiçbir şey onaylamadı (onay damgası yok) → "Onaylandı" yazmak yanıltıcı olur, rozet gösterilmez.
export function getSecondaryContactState(contact) {
  const raw = contact?.status;
  if (raw === undefined || raw === null || String(raw).trim() === "") return "";
  const status = Number(raw);
  if (status === SECONDARY_CONTACT_STATUS.PENDING) return "pending";
  if (status === SECONDARY_CONTACT_STATUS.REJECTED) return "rejected";
  if (status === SECONDARY_CONTACT_STATUS.APPROVED) {
    const confirmed = Number(contact?.confirmedDateTime ?? contact?.confirmed_date_time ?? 0);
    return confirmed > 0 ? "approved" : "legacy";
  }
  return "";
}

// Rozet metni/tonu. legacy ve bilinmeyen durumda rozet yok (null).
const STATE_BADGES = {
  pending: { label: "Onay bekliyor", tone: "pending" },
  approved: { label: "Onaylandı", tone: "approved" },
  rejected: { label: "Reddedildi", tone: "rejected" },
};
export function getSecondaryContactBadge(contact) {
  if (!SECONDARY_CONTACT_APPROVAL_FLOW) return null;
  return STATE_BADGES[getSecondaryContactState(contact)] || null;
}

// Davet yeniden gönderilebilir mi (MAİL ATAR): kayıtlı (contactID'li), onay bekleyen ya da reddetmiş,
// e-postası olan kişi. Sınırlar (1 saat / 5 gönderim) BE'de; buton ona güvenir, hatayı gösterir.
export function canResendSecondaryInvite(contact) {
  if (!SECONDARY_CONTACT_APPROVAL_FLOW) return false;
  const state = getSecondaryContactState(contact);
  if (state !== "pending" && state !== "rejected") return false;
  return String(contact?.contactID ?? "").trim() !== "" && String(contact?.secondaryEmail ?? "").trim() !== "";
}

// Eksik sayılır: listede hiç kişi yoksa ya da listedeki HERKES daveti reddettiyse (kim eklemiş
// olursa olsun). Onay bekleyen kişi eksik SAYILMAZ: müşterinin yapacağı bir şey yok, kişinin yanıtı bekleniyor.
// contacts: secondaryContacts dizisi. undefined = henüz bilinmiyor → eksik SAYILMAZ (yanlış uyarı çıkmasın).
export function isSecondaryContactMissing(contacts) {
  if (contacts === undefined) return false;
  if (!Array.isArray(contacts)) return true;
  // Onay akışı kapalı: onay/red durumuna bakılmaz, en az bir kişi eklenmiş olması yeterli.
  if (!SECONDARY_CONTACT_APPROVAL_FLOW) return contacts.length === 0;
  return !contacts.some((c) => getSecondaryContactState(c) !== "rejected");
}

// Profil kaydı sonrası Sidebar ve anasayfa yeniden çeksin diye yayınlanan olay.
export const SECONDARY_CONTACT_UPDATED_EVENT = "troy:secondary-contact-updated";
export function emitSecondaryContactUpdated() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(SECONDARY_CONTACT_UPDATED_EVENT));
}

// ZORUNLULUK KOŞULU (kullanıcı kararı 29.09.2026): ikincil irtibat kişisi yalnız bir DEPOLAMA
// teklifini KABUL etmiş müşteride zorunludur ve yalnız onda "eksik" gösterilir.
// Kabul = teklif statüsü 7 (müşteri kabul etti) ya da 1 (onaylandı); depolama = talep tipi "new-storage".
const ACCEPTED_OFFER_STATUSES = new Set(["1", "7"]);
export const STORAGE_REQUEST_TYPE = "new-storage";

// offers: get-offers sonucu. Dizi değilse (henüz çekilmedi / istek başarısız) undefined döner →
// çağıran "bilinmiyor" sayar ve uyarı göstermez.
export function hasAcceptedStorageOffer(offers, userID = "") {
  if (!Array.isArray(offers)) return undefined;
  const me = String(userID || "").trim();
  return offers.some((offer) => {
    if (!ACCEPTED_OFFER_STATUSES.has(String(offer?.status ?? "").trim())) return false;
    if (String(offer?.requestType ?? offer?.request_type ?? "").trim() !== STORAGE_REQUEST_TYPE) return false;
    const owner = String(offer?.userID ?? offer?.user_id ?? "").trim();
    return !me || !owner || owner === me;
  });
}

// Tamamlanma hesabına verilecek değer: zorunlu değilse (ya da bilinmiyorsa) undefined → madde yok.
export function secondaryContactForCompletion(contact, required) {
  return required === true ? contact : undefined;
}
